import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";





const save = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "holiday/holiday-action", data, headerConfig);
        return response.data;
  };


const list = async () => {
    const response = await axios
        .post(BASE_API_URL + "holiday/holiday-list", {}, headerConfig);
        return response;
};


const deleteholiday = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "holiday/delete", data, headerConfig);
        return response.data;
  };




const holidayService = {
    save,
    list,
    deleteholiday
};

export default holidayService;